<template>
    <div class="wrapper success_base">
        <div class="success_title">
<!--            <img src="../../assets/image/secondary/success.png" class="success_title_img">-->
            <p class="title">恭喜你报名成功</p>
        </div>
        <!-- 头图 -->
        <div class="success_from" style="width: 94%;margin-top: 30px">
            <!--            <img src="../../assets/image/secondary/give.jpg" class="succes_give_img">-->
            <div class="activity_info">
                <p>
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-shijian"></use>
                    </svg>
                    <span>{{ title}}</span>
                </p>
                <p>
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-shijian"></use>
                    </svg>
                    <span>{{ stime_etime}}</span>
                </p>
                <p v-if="address!=''">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-didian"></use>
                    </svg>
                    <span>{{ address}}</span>
                </p>
            </div>
            <div class="divider_box">
                <el-divider><b>帮朋友报名</b></el-divider>
            </div>
            <div class="success_sign_form">

                <van-form ref="actionForm" style="padding-bottom: 5px">
                    <div class="field_outbox">
                        <van-field
                                :border="false"
                                v-model="action_form.name"
                                name="姓名"
                                placeholder="请输入朋友姓名"
                        />
                    </div>
                    <div class="field_outbox">
                        <van-field
                                :border="false"
                                type="tel"
                                v-model="action_form.phone"
                                name="电话"
                                placeholder="请输入朋友电话"
                        />
                    </div>
                    <div class="field_outbox" v-if="is_city">
                        <van-field
                                :border="false"
                                v-if="is_city"
                                v-model="action_form.city"
                                is-link
                                readonly
                                placeholder="请帮朋友选择城市"
                                @click="city_show = true"
                        />
                    </div>
                    <div v-if="tid!=5">
                        <div class="field_outbox">
                            <van-field
                                    :border="false"
                                    v-model="action_form.car_name"
                                    is-link
                                    readonly
                                    placeholder="请帮朋友选择意向车型"
                                    @click="is_dialog_car = true"
                            />
                        </div>
                    </div>
                    <div class="submit_btn" @click="submitForm" style="margin-top: 20px">立即赠票</div>

                    <div class="tip_wrapper">
                        <p>
                            1. 您已成功报名{{title}}
                        </p>
                        <p>
                            2. 请于{{stime_etime}}前往{{address}}逛展
                        </p>
                    </div>
                </van-form>
            </div>
        </div>
        <!-- 报名成功弹框-->
        <van-overlay :show="is_success" @click="is_success = false">
            <div class="wrapper" @click.stop
                 style="display: flex;align-items: center;justify-content: center;height: 100%;">
                <div class="success_block">
                    恭喜您赠票成功
                </div>
            </div>
        </van-overlay>

        <!-- 城市弹框-->
        <!--:style="{height: '50%'}" :lock-scroll="false"-->
        <van-popup v-model="city_show" round position="bottom" :safe-area-inset-bottom="true">
            <!--  style="height: 100%;overflow-x: hidden;overflow-y: auto"-->
            <van-cascader
                    v-model="cascaderValue"
                    title="请选择所在地区"
                    :options="citys"
                    :fieldNames="cityNames"
                    @close="city_show = false"
                    @finish="finishCity"
                    class="city_cascader"
            />
        </van-popup>
    </div>
</template>

<script>
    import countDown from "@/components/countDown";
    import policy from "@/components/policy";
    import copyright from "@/components/copyright";
    import banner from "@/components/banner";
    import _geturl from "@/utils/_geturl";
    import lib_activity from "@/libs/lib_activity";
    import lib_city from "@/libs/lib_city";
    import _wx from "@/common/_wx";
    import _time from "@/utils/_time";
    import _object from "@/utils/_object";
    import _regular from "@/utils/_regular";
    import lib_clue from "@/libs/lib_clue";
    import lib_success from "@/libs/lib_success";
    import cache_url from "@/cache/cache_url";
    import Toast from "vant/lib/toast";
    import _monitor from "@/monitor/_monitor";

    let action_form = {
        name: '', //姓名
        phone: '', //电话
        city: '', //城市
    }

    export default {
        name: "jianzhancommon",
        components: {
            countDown,
            policy,
            copyright,
            banner,
        },
        data() {
            return {
                title: '', // document的title
                address: '', //活动地址
                activity_id: 0, //活动ID
                tids: "", //模板ID
                channel: '', //渠道
                channel_name: '', //渠道名
                tid: 0, // 有无车型库
                share_theme: '', //分享描述
                stime: 0, // 项目开始时间
                etime: 0, // 项目结束时间
                stime_etime: '', //活动时间段
                ui: {
                    head: '', //头图
                    tail: '', //详情图
                    share: '', //分享图
                    bg_color: '', //表单背景色
                    font_color: '', //文本颜色
                    btn_bg_color: '', //按钮背景色
                    btn_font_color: '', //按钮文本颜色
                    btn_text: '', //按钮文本值
                    btm_btn_text: '', //底部按钮文本
                    is_banner: 0, //是否有轮播图
                    is_counter: 0, //是否有倒计时
                    is_copyright: 1, //协议
                    jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
                },

                action_form: action_form,
                //城市联级选择
                citys: [], //城市数据
                cascaderProps: { //配置项
                    expandTrigger: 'hover', //展开方式
                    value: "id", //指定选项的值
                    label: "name", //指定选项标签
                    children: "children", //指定选项的子选项
                    emitPath: false, //该节点数组
                },

                is_success: false, //报名成功弹框
                is_city: false, //表单城市项，默认无城市
                is_stop: false, //活动是否已结束
                is_display: true, //底部按钮
                btn_show: false, //底部按钮显隐


                // vant相关
                city_show: false,
                cascaderValue: '', //
                cityNames: {
                    text: 'name',
                    value: 'id',
                    children: 'children',
                },
            }
        },
        created() {
            // 地址栏
            this.activity_id = _geturl("activity_id");
            this.tids = _geturl("tids");
            this.channel = _geturl("channel");
            this.channel_name = _geturl("channel_name");

            //获取项目信息
            lib_activity.info(this.activity_id, this.tids, this.init_info);

            //监测
            _monitor.init(this.channel, this.activity_id);

        },
        mounted() {
            // 监听页面滚动
            window.addEventListener('scroll', this.handleScroll, true)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll, true)
        },
        destroyed() {
            // window.removeEventListener('scroll', this.handleScroll())
        },
        methods: {
            //初始化项目信息
            init_info(data) {
                console.log(data)
                this.title = data.activity.theme;
                document.title = this.title;
                this.address = data.activity.address
                this.share_theme = data.activity.share_theme;
                this.etime = data.activity.etime;
                this.stime = data.activity.stime;
                this.stime_etime = _time._range_date(this.stime*1000, this.etime*1000);
                this.tid = data.activity.tid;
                if(data.ui == null) {
                    this.ui = {};
                    return;
                }
                this.ui = data.ui;

                // 项目结束
                if (!data.activity.state || (_time._current() > data.activity.etime)) {
                    this.is_stop = true;
                    return;
                }
                // 判断是否有城市
                let city = []
                if (data.activity.city) {
                    city = data.activity.city.split(',');
                }
                if (city.length == 1 && city[0] > 0) {
                    //单城市项目
                    this.is_city = false;
                } else {
                    //多城市项目
                    this.is_city = true;
                    this.getCity(data.activity.city)
                }
                // 分享： ui存在再分享
                if (_object._length(this.ui) > 0) {
                    this.share();
                }
            },

            // 分享
            share() {
                let that = this;
                lib_activity.share(function (data) {
                    let options = {};
                    options.title = that.title;
                    options.desc = that.share_theme;
                    options.link = window.location.href;
                    options.image = that.ui.share;

                    _wx.js_api(data, _wx.share, options);
                })
            },
            // 加载城市
            getCity(city) {
                let that = this;
                lib_city.list(city, function (data) {
                    that.citys = data;
                })
            },

            submitForm() {
                if (this.is_city && !this.action_form.city) {
                    Toast('请选择城市');
                    return;
                }
                if (!this.action_form.name) {
                    Toast('请输入姓名');
                    return;
                }
                if(this.action_form.name  && !_regular.is_china(this.action_form.name)) {
                    Toast('请输入正确的姓名');
                    return;
                }
                if (!this.action_form.phone) {
                    Toast('请输入手机号');
                    return;
                }
                if (!_regular.is_mobile(this.action_form.phone)) {
                    Toast('请输入正确的手机号');
                    return;
                }
                let cityArr = this.action_form.city.split('/'); // vant形式
                let location = this.is_city ? (cityArr[0] + '+' + cityArr[1]) : '';
                let url = window.location.href;
                let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
                let params = {
                    activity_id: this.activity_id,
                    channel_code: this.channel,
                    channel_name: this.channel_name,
                    location,
                    url,
                    form_name: this.action_form.name,
                    form_phone: this.action_form.phone,
                    form_ui_id,
                };
                let that = this;
                console.log(params, '入参')
                // that.is_success = true
                // setTimeout(() => {
                //     that.is_success = false
                // }, 2000);
                // return;
                lib_clue.receive(params, function (data) {
                    that.is_success = true
                    //监测上报
                    _monitor.submit()

                    //缓存当页面链接
                    cache_url.set(window.location.href)

                    //跳转
                    setTimeout(() => {
                        that.is_success = false
                    }, 2000);
                    //不同参数跳转不同页面
                    const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 0
                    // //跳转地址
                    // const url = lib_success.jmp_url(jmp_url)
                    // that.$router.push({
                    //     path: url,
                    //     query: {
                    //         id: data.id
                    //     },
                    // })
                })
            },

            // 滚到表单开始部分
            btn_click_form() {
                let form_top = this.$refs.main.offsetTop - 50;
                document.documentElement.scrollTop = form_top
                document.body.scrollTop = form_top;
                document.querySelector('#app').scrollTop = form_top
            },
            // 滚动
            handleScroll() {
                let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('#app').scrollTop;
                this.$nextTick(() => {
                    if (scrollHeight >= this.$refs.tailImage.offsetTop) {
                        this.btn_show = true;
                    } else {
                        this.btn_show = false;
                    }
                })
            },

            // vant相关
            finishCity({selectedOptions}) {
                this.city_show = false;
                this.action_form.city = selectedOptions.map((option) => option.name).join('/');
            },
        },
    };
</script>

<style lang="less" scoped>
    /*@import "../../assets/style/autoshow/base.less";*/
    @import "../../assets/style/autoshow/form.less";
    // form部分
    @import "../../assets/style/common/successful.less"; //报名成功
    @import "../../assets/style/secondary/base.less";
    .city_cascader {
        /deep/ .van-tabs .van-tabs--line .van-cascader__tabs {
            overflow-y: auto;
        }
    }

    /*建站*/
    .mt0 {
        margin-top: 0px;
    }

    .form_btn_img {
        width: 100%;
        height: auto;
        margin-top: 8px;

        img {
            display: inline-block;
            width: 100%;
        }
    }

    .succes_form_body {
        .el-form-item {
            margin-bottom: 10px;
        }
    }

    .field_outbox {
        margin-bottom: 10px;
    }

    .tip_wrapper{
        margin-top: 20px;
        font-size: 24px;
        color: #999999;
        padding-bottom: 10px;

    }
    .tip_wrapper p{
        margin-bottom: 6px;
    }
    .success_block{
        background-color: #fff;
        padding: 40px 30px;
        border-radius: 10px;
        font-weight: bold;
        color: red;
        font-size: 16px;
        letter-spacing: 1.2px;
    }
</style>

